import { inject, Injectable } from '@angular/core';
import { EDeliverableType } from '@enums/campaign.enum';
import { IDeliverableConfig } from '../deliverable-list.interface';
import { ImageDeliverableService } from '../shared/image-deliverable/image-deliverable.service';
import { ContentComponent } from './content.component';

@Injectable({ providedIn: 'root' })
export class ContentService {
  private readonly imageDeliverableService = inject(ImageDeliverableService);

  public getConfig(): IDeliverableConfig {
    return this.imageDeliverableService.getConfig({
      component: ContentComponent,
      defaultNameTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.contentDeliverable.title',
      deliverableType: EDeliverableType.content,
    });
  }
}
